import script from "./SelectYourCityForJobPost.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectYourCityForJobPost.vue?vue&type=script&setup=true&lang=js"

import "./SelectYourCityForJobPost.vue?vue&type=style&index=0&id=5d4d9c06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d4d9c06"]])

export default __exports__